<!-- <div class="boxContainer">
  <div>
    <h2 class="boxContainer_titulo linha-texto">Conheça Osasco</h2>
  </div>
  <ul class="configuracoesList">
    <ng-container *ngFor="let item of paginatedItems">
      <a [routerLink]="['/info', item.nome]">
        <li class="configuracoesList_item">
          <img [src]="item.icon" class="configuracoesList_item_icon" />
          {{ item.nome }} <br />
          <span class="subItem">{{ item.count }} itens</span>
        </li>
      </a>
    </ng-container>
  </ul>

 <ul class="configuracoesList">
    <ng-container *ngFor="let item of paginatedItems">
      <li class="configuracoesList_item" (click)="getInfoCards2(item.codEntidadeNegocio, item.codCatalogo)">
        <img [src]="item.icon" class="configuracoesList_item_icon" />
        {{ item.nome }} <br />
        <span class="subItem">{{ item.count }} itens</span>
      </li>
    </ng-container>
  </ul> 

  <div class="pagination mt-3">
    <div class="pagination-dots">
      <span class="paginacao-cards" *ngFor="let dot of paginationDots; let i = index" (click)="goToPage(dot)"
        [class.active]="dot === currentPage">
      </span>
    </div>
  </div>
</div>-->

<div id="loading" *ngIf="loading">
  <img src="../../../assets/images/icon_gier.png" alt="Loading" />
</div>
